
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  mixins: [staticBlockMixin],
  data () {
    return {
      form: {
        params: [] as any[],
        typeId: this.$config?.app?.forms?.ids?.RECALL,
        siteId: this.$authNew.siteId,
        active: true
      },
      isValidePhone: false,
      triggerAnimation: false,
      triggerValidate: false,
      formLoaded: false,
      emailData: {
        to: '',
        subject: 'Остались вопросы?',
        text: '',
        html: ''
      },
      secondPartOfMail: '',
      thirdPartOfMail: `
        <table style="width: 100%; border: none; background-color: #fff; margin: 0; padding: 0; border-collapse: collapse;">
          <tbody>
              <tr>
                <td style="padding: 36px; background-color: #31509A; border-radius: 15px;">
                    <table style="width: 100%; border: none; margin: 0; padding: 0; border-collapse: collapse;">
                      <tbody>
                          <tr>
                            <td style="padding: 0; text-align: center">
                                <p style="font-family: 'Inter Tight', Arial, sans-serif; font-size: 26px; line-height: 30px; text-align:center;color: #fff; margin: 0; padding: 0">
                                  8-800-700-92-22
                                </p>
                                <p style="font-family: 'Inter Tight', Arial, sans-serif; font-size: 12px; line-height: 20px; text-align:center;color: #fff; margin: 0; padding: 0">
                                  Единый бесплатный номер по России
                                </p>
                            </td>
                          </tr>
                      </tbody>
                    </table>
                </td>
              </tr>
          </tbody>
        </table>`
    }
  },
  computed: {
    firstPartOfMail () {
      return `
        <table style="width: 640px; margin: 0 auto; border: none; padding: 0; background-color: #fff; border-collapse: collapse;">
            <tbody>
               <tr>
                  <td style="padding: 20px;">
                     <!--header -->
                     <table style="width: 100%; border: none; background-color: #fff; margin: 0; padding: 0; border-collapse: collapse;">
                        <tbody>
                           <tr>
                              <td style="padding: 20px 0 40px; border-bottom: 1px solid #31509A;">
                                 <table style="width: 100%; border: none; margin: 0; padding: 0; border-collapse: collapse;">
                                    <tbody>
                                       <tr>
                                          <td style="padding: 0; text-align: center">
                                             <img src="${this.$config.S3_DOMAIN}/icons/logotype.png" alt="" width="154" height="40" style="display:block; margin: 0 auto;">
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     
                     <!-- Existing content -->
                    <table style="width: 100%; border: none; margin: 0 0 40px; padding: 0; border-collapse: collapse;">
              <tbody>
                <tr>
                    <td style="padding: 0; text-align: left;">
                      <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 24px; line-height: 30px; font-weight: bold; text-align: center; color: #000; margin: 0 0 20px; padding: 0">
                          Поступила новая заявка с сайта
                      </p>
                      <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px; text-align: center; color: #000; margin: 0; padding: 0">
                          Из формы Остались вопросы?

                      </p>
                    </td>
                </tr>
              </tbody>
          </table>
          `
    }
  },
  async mounted () {
    try {
      const data = await this.$forms.fetchFormParams(this.form.typeId)
      this.emailData.to = this.$configProvider?.config?.['manager-emails']?.forms?.emails.find(item => item.id === 11)?.emails?.join(', ') || ''
      this.form.params = data.map(field => ({
        id: field.id,
        value: ''
      }))

      this.formLoaded = true
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    onChangePhone ({ value, valide }) {
      this.isValidePhone = valide
      this.form.params[0].value = value
    },
    async sendEmail () {
      const maxRetries = 5
      let attempts = 0
      while (attempts < maxRetries) {
        attempts++
        try {
          const response = await fetch('/api/send-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.emailData)
          })

          const result = await response.json()
          console.log(this.emailData)
          if (result.success) {
            this.$toast.success(result.message)
            return
          } else {
            console.error(`Попытка ${attempts}: ${result.message} ${result.error}`)
          }
        } catch (error) {
          console.error(`Попытка ${attempts}: ошибка запроса`, error)
        }
        if (attempts < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }
    },
    async subscribe () {
      this.triggerValidate = true

      setTimeout(() => {
        this.triggerValidate = false
      }, 200)

      if (!this.isValidePhone) { return }
      this.secondPartOfMail = `
          <table style="width: 100%; border: none; margin: 0 0 20px; padding: 0; border-collapse: collapse; border-bottom: 1px solid #EAEAEA;">
              <tbody>
                  <tr>
                      <td style="padding: 0 0 20px; text-align: left;">
                        <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 14px; line-height: 20px; text-align: left; color: #898989; margin: 0; padding: 0">
                            Телефон
                        </p>
                        <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px; text-align: left; color: #000; margin: 0; padding: 0; font-weight: bold;">
                            ${this.form?.params?.[0]?.value}
                        </p>
                      </td>
                  </tr>      
              </tbody>
          </table>
          `
      this.emailData.html = this.firstPartOfMail + this.secondPartOfMail + this.thirdPartOfMail
      try {
        await this.$forms.createForm(this.form)

        this.form.params[0].value = ''
        this.$refs.phoneInput.localValue = ''
        this.isValidePhone = false
        await this.sendEmail()
        this.$toast.success('Ваша заявка успешно создана')
      } catch (e: any) {
        this.$toast.error(e?.message)
      }
    }
  }
})
